//Mapa crack e mapa fronteira
const colorMapping = {
	alto: 'var(--indice-alto)',
	medio: 'var(--indice-medio)',
	baixo: 'var(--indice-baixo)',
	semProblemas: 'var(--indice-sem-problemas)',
	semResposta: 'var(--indice-sem-resposta)'
};


const normalizeResponse = (response) => {
	const normalized = response.toLowerCase().trim();
	switch (normalized) {
			case 'alto':
				case '["Alto"]':
					case '"Alto"':
					return 'alto';
			case 'médio': 
			case 'média':
					return 'medio';
			case 'baixo':
					return 'baixo';
			case 'sem problemas':
					return 'semProblemas';
			case 'sem resposta':
					return 'semResposta';
			default:
					return 'semResposta'; 
	}
};

export const getColorByResponse = (response) => {
	const normalizedResponse = normalizeResponse(response); 
	return colorMapping[normalizedResponse] || colorMapping.semResposta; 
};

export const getColorMapping = () => colorMapping; 




//Mapa da Assistencia 
export const getColorByFilterAndResponse = (rede, resposta) => {
	const colorMapping = {
		cras: { sim: 'var(--cras-sim)', nao: 'var(--sem-rede)' },
		creas: { sim: 'var(--creas-sim)', nao: 'var(--sem-rede)' },
		nasf: { sim: 'var(--nasf-sim)', nao: 'var(--sem-rede)' },
		comad: { sim: 'var(--comad-sim)', nao: 'var(--sem-rede)' },
		outras: { sim: 'var(--outras-sim)', nao: 'var(--sem-rede)' },
		creaspop: { sim: 'var(--creaspop-sim)', nao: 'var(--sem-rede)' },
		conselho: { sim: 'var(--conselho-sim)', nao: 'var(--sem-rede)' }
		// Adicione as outras redes aqui
	};

	// Normaliza a resposta para tratar os casos de 'sim', 'não' e 'nao'
	const normalizeResponse = (resposta) => {
		if (!resposta) return 'nao'; // Se a resposta for nula ou indefinida, retorna 'nao'
		const normalized = resposta.toLowerCase().trim();
		if (normalized === 'não' || normalized === 'nao') {
			return 'nao';  // Normaliza para 'nao'
		}
		if (normalized === 'sim') {
			return 'sim';  // Normaliza para 'sim'
		}
		return 'nao';  // Qualquer outra resposta retorna como 'não'
	};

	// Obtém as cores para a rede e para a resposta normalizada
	const redeColors = colorMapping[rede.toLowerCase()] || {};
	return redeColors[normalizeResponse(resposta)] || 'steelblue';  // Retorna a cor ou uma cor padrão
};
